import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight, Facebook, Instagram, Youtube } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { api, errMsg } from "@/lib/api";

const TikTok = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden {...props}><path d="M16.6 5.82a4.28 4.28 0 0 1-1.04-2.82h-3.1v12.4a2.6 2.6 0 1 1-2.6-2.6c.27 0 .53.04.78.12V9.75a5.7 5.7 0 1 0 4.92 5.65V9.01a7.3 7.3 0 0 0 4.24 1.35V7.27a4.28 4.28 0 0 1-3.2-1.45Z" /></svg>
);
// Replace these with the store's real profile URLs
const SOCIALS = [
  ["Instagram", Instagram, "https://www.instagram.com/"],
  ["TikTok", TikTok, "https://www.tiktok.com/"],
  ["YouTube", Youtube, "https://www.youtube.com/"],
  ["Facebook", Facebook, "https://www.facebook.com/"],
];

export function Footer() {
  const { t } = useStore();
  const [email, setEmail] = useState("");
  const cols = [
    [t("shop"), [["/shop", t("allProducts")], ["/shop?is_new=1", t("newIn")], ["/shop?bestseller=1", t("bestSellers")], ["/shop?on_sale=1", t("sale")]]],
    [t("brands"), [["/collections/nike", "Nike"], ["/collections/air-jordan", "Air Jordan"], ["/collections/adidas", "Adidas"], ["/collections/new-balance", "New Balance"], ["/collections/puma", "Puma"], ["/collections/asics", "Asics"]]],
    [t("help"), [["/checkout", t("checkout")], ["/wishlist", t("wishlist")], ["/admin", "Admin"]]],
  ];
  return (
    <footer className="relative overflow-hidden bg-ink text-sun" data-testid="site-footer">
      <div className="container-x pt-20 text-center">
        <Link to="/" className="wordmark text-5xl sm:text-7xl lg:text-8xl" data-testid="footer-logo">CASABLANCA</Link>
        <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.6em] text-lavender">Shop · {t("footerTag")}</p>
        <div className="mt-8 flex justify-center gap-3" data-testid="footer-socials">
          {SOCIALS.map(([name, Icon, href]) => (
            <a key={name} href={href} target="_blank" rel="noreferrer" aria-label={name} data-testid={`social-${name.toLowerCase()}`}
              className="grid h-11 w-11 place-items-center rounded-full border border-sun/25 transition-[background-color,color,border-color] duration-300 hover:border-lavender hover:bg-lavender hover:text-ink">
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>
      <div className="container-x mt-16 grid gap-12 border-t border-sun/15 py-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="eyebrow text-sun/60">{t("newsletter")}</p>
          <form className="mt-6 flex max-w-md border-b border-sun/30 pb-3"
            onSubmit={(e) => { e.preventDefault(); api.post("/newsletter", { email }).then(() => { toast.success(t("subscribe"), { description: email }); setEmail(""); }).catch((er) => toast.error(errMsg(er))); }}>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email@domain.com" data-testid="newsletter-input"
              className="w-full bg-transparent text-lg text-sun outline-none placeholder:text-sun/30" />
            <button type="submit" aria-label={t("subscribe")} data-testid="newsletter-submit-btn" className="transition-colors hover:text-lavender"><ArrowRight className="h-5 w-5" /></button>
          </form>
        </div>
        {cols.map(([title, links]) => (
          <div key={title} className="lg:col-span-2">
            <p className="eyebrow mb-5 text-sun/50">{title}</p>
            <ul className="space-y-2.5">
              {links.map(([to, label]) => <li key={to + label}><Link to={to} className="link-u text-sm text-sun/80 hover:text-sun">{label}</Link></li>)}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-sun/10">
        <div className="container-x flex flex-col justify-between gap-2 py-6 font-mono text-[10px] uppercase tracking-[0.2em] text-sun/40 sm:flex-row">
          <span>© {new Date().getFullYear()} CASABLANCA</span>
          <span>EUR · Europe · Stripe</span>
        </div>
      </div>
    </footer>
  );
}
